<template>
  <div style="height:100%" class="deptTree">
    <el-scrollbar style="height:100%" >
      <el-tree
        ref="tree"
        node-key="id"
        :props="{
              label: 'name',
              children: 'zones',
              isLeaf: 'leaf',
              disabled:'disabled'
            }"
        :load="loadNode"
        :default-checked-keys="checkedDept"
        @node-click="onNodeClick"
        @check="getCheckNode"
        @check-change="changSatus"
        :default-expanded-keys="defaultExpandedKeys"
        :expand-on-click-node="false"
        lazy
        show-checkbox
        :check-strictly="true"
        v-if="invalid"
      ></el-tree>
      <el-tree
        node-key="id"
        :props="{
              label: 'name',
              children: 'zones',
              isLeaf: 'leaf'
            }"
        :load="loadNode"
        @node-click="onNodeClick"
        :default-expanded-keys="defaultExpandedKeys"
        :expand-on-click-node="false"
        lazy
        v-if="!invalid"
      ></el-tree>
    </el-scrollbar>
  </div>
  
</template>

<script>
export default {
  data() {
    return {
      defaultExpandedKeys: [],
      node:[],
      resolve:function(){},
      isFirst:true,
      checkedDept:[],
    };
  },
  props:["invalid","departments","haveChange"],
  computed:{
    
  },
  created(){
    if(this.departments){
      this.departments.forEach(elm=>{
        this.checkedDept.push(elm.departmentId);
      })
    }
    this.loadNode(this.node,this.resolve);
  },
  methods: {
    changSatus(){
      this.$emit("changeStatus",true)
    },
    getCheckNode(now,all){
      this.$emit("checkAll", all.checkedNodes);
    },
    loadNode(node, resolve) {console.log(node.data)
      if (node.level === 0) {
        if(this.isFirst){
          this.isFirst=false;
          this.node=node;
          this.resolve=this.resolve;
        }
        this.$api.getRootDepartment(this.$route.query.domainid, {
          onSucess: resp => {
            let rootDepartment = resp.data.data;
            if(rootDepartment){
              let have=false;
              for(let i=0;i<this.checkedDept.length;i++){
                if(rootDepartment.id==this.checkedDept[i]){
                  have=true;
                }
              }
              if(have||rootDepartment.editFlag!=="true"){
                rootDepartment.disabled=true;                  
              }
              resolve([rootDepartment]);
              //加载列表
              this.defaultExpandedKeys.push(rootDepartment.id);
            }
            
          }
        });
      }
      if (node.level >= 1) {
        this.$api.getSubDepartmentNodes(this.$route.query.domainid, node.key, {
          onSucess: resp => {
            let subdepts = resp.data.data;
            if(subdepts){
              let validDept =[];
              subdepts.forEach((elm)=>{
                let have=false;
                for(let i=0;i<this.checkedDept.length;i++){
                  if(elm.id==this.checkedDept[i]){
                    have=true;
                  }
                }
                if(have||elm.editFlag!=="true"){
                  elm.disabled=true;                  
                }
                if(elm.valid){
                  validDept.push(elm);
                }
              })
              if(this.invalid){
                resolve(validDept);
                
              }else{
                resolve(subdepts);
              }
            }else{
              subdepts=[];
              resolve(subdepts);
            }
          }
        });
      }
    },

    onNodeClick(dept) {
      console.log(dept)
      if(dept.editFlag==="true"){
        this.$emit("node-click", dept);
      }else{
        this.$message({type:"warning",message:"您无此部门的管理权限，无法进行操作"})
      }
    },

  }
};
</script>

<style lang="scss" scoped>
</style>